<script>
import { mapActions, mapGetters } from 'vuex';
import TableView from '@/components/elements/views/TableView';
import ConfirmCancelModal from '@/components/elements/ConfirmationModal';

export default {
    components: {
        ConfirmCancelModal
    },

    page: {
        title: 'Events'
    },

    extends: TableView,

    data() {
        return {
            eventId: null,
            pageTitle: 'Events',
            actions: [
                {
                    icon: 'far fa-calendar-times',
                    method: 'showCancelEventModal',
                    where: {
                        status: {
                            value: 'cancelled',
                            operator: 'not'
                        }
                    }
                }
            ]
        };
    },

    computed: {
        ...mapGetters({
            CANCELLED: 'events/CANCELLED'
        }),

        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    value: 'date',
                    type: 'date',
                    width: '150px',
                    filter: val => this.$dayjs(val).format('YYYY-MM-DD HH:mm')
                },
                {
                    value: 'price',
                    type: 'number',
                    filter: 'formatPrice',
                    width: '130px'
                },
                {
                    value: 'agudaPrice',
                    type: 'number',
                    filter: 'formatPrice',
                    width: '130px'
                },
                {
                    value: 'campuses',
                    width: '200px',
                    filterFieldName: 'campuses.name',
                    sortable: false,
                    filter: 'joinTable'
                },
                {
                    value: 'description',
                    filter: 'rawText',
                    width: '180px'
                },
                {
                    value: 'payWithStars',
                    width: '100px',
                    type: 'boolean',
                    filter: val => (val ? 'Yes' : '-')
                },
                {
                    value: 'location',
                    width: '150px'
                },
                {
                    value: 'status',
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        },

        additionalComponents() {
            return [
                {
                    name: 'confirm-cancel-modal',
                    props: {
                        id: 'confirm-cancel-event-modal',
                        title: 'Cancel event'
                    },
                    events: {
                        agree: this.onCancel
                    }
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'events/index',
            deleteItem: 'events/destroy',
            cancelEvent: 'events/cancel'
        }),

        onRowClick({ id }) {
            this.$router.push(`/events/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/events/add');
        },

        showCancelEventModal(id) {
            this.eventId = id;
            this.$bvModal.show('confirm-cancel-event-modal');
        },

        async onCancel() {
            try {
                await this.cancelEvent(this.eventId);

                const item = this.items.find(item => item.id === this.eventId);
                item.status = this.CANCELLED;
                this.eventId = null;

                this.$toaster('Event has been canceled.');
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
